import {LogaProxy} from "./LogaProxy";
import moment from "moment";

export class DailyWorkerScheduleTemplateSlot {
  /**id in database**/
  public id: number;

  /**index to tell if this is the first, second... slot of the day**/
  public slotIndex: number;

  /**Hour of start, as simple int, should be between 0 and 23**/
  public startH: number;

  /**Minute of start, as simple int, should be between 0 and 59**/
  public startM: number;

  /**duration of the slot in minutes**/
  public duration: number;

  /**id of the template it belongs to**/
  public template: number;

  public uiTemplate: LogaProxy;

  public uiTemplateName: string;
  public uiHrDuration: string;

  static toJson(as: DailyWorkerScheduleTemplateSlot): DailyWorkerScheduleTemplateSlot {
    if (as == null) return null;

    let aa = new DailyWorkerScheduleTemplateSlot();
    aa.id = as.id;
    aa.slotIndex = as.slotIndex;
    aa.startH = as.startH;
    aa.startM = as.startM;
    aa.duration = as.duration;
    aa.template = as.template;
    aa.uiTemplate = as.uiTemplate;
    return aa;
  }
}

export class SlotsForStoreReportSlot {
  public id: number;
  public day: number;
  public resourceLane: number;
  public resourcePool: string;
  public indexInDay: number;
  public operation: LogaProxy;
  public assignedScheduleSlot: DailyWorkerScheduleTemplateSlot;
  public activity: number;
  public displayName: string;

  public openForPlanning: boolean;
  public plannedStoreName: null;

  public suggestedTypeOfWorker: string;


  static fromJson(s: SlotsForStoreReportSlot): SlotsForStoreReportSlot {
    if (s == null) return null;
    let slot = new SlotsForStoreReportSlot();
    slot.id = s.id;
    slot.day = s.day;
    slot.resourceLane = s.resourceLane;
    slot.resourcePool = s.resourcePool;
    slot.indexInDay = s.indexInDay;
    slot.operation = s.operation;
    slot.assignedScheduleSlot = DailyWorkerScheduleTemplateSlot.toJson(s.assignedScheduleSlot);
    slot.activity = s.activity;
    slot.displayName = s.displayName;
    slot.openForPlanning = s.openForPlanning;
    slot.plannedStoreName = s.plannedStoreName;
    slot.suggestedTypeOfWorker = s.suggestedTypeOfWorker;
    return slot;
  }
}

export class SlotsForStoreReport {
  public slots: SlotsForStoreReportSlot[] = [];

  /**
   * builder form JSON to get "instances"
   * @param oo
   */
  static fromJson(oo: SlotsForStoreReport) {
    let r: SlotsForStoreReport = new SlotsForStoreReport();
    r.slots = [];

    if (oo.slots != null)
      oo.slots.forEach(s => {
        r.slots.push(SlotsForStoreReportSlot.fromJson(s))
      })

    return r;
  }
}


/**
 *  -- TEMPLATES
 **/

export class DailyWorkerScheduleTemplate {
  public id: number;
  public name: string;
  public code: string;
  public slots: DailyWorkerScheduleTemplateSlot[] = [];

  static fromJson(oo: DailyWorkerScheduleTemplate): DailyWorkerScheduleTemplate {
    let t: DailyWorkerScheduleTemplate = new DailyWorkerScheduleTemplate();
    t.id = oo.id;
    t.name = oo.name;
    t.code = oo.code;
    t.slots = [];
    if (oo.slots != null)
      oo.slots.forEach(sl => {
        let ssl = DailyWorkerScheduleTemplateSlot.toJson(sl);
        ssl.uiTemplateName = t.name;
        ssl.uiHrDuration = moment.duration(ssl.duration, "minutes").toISOString();
        t.slots.push(ssl);
      });
    return t;
  }
}

export class OperationDailyWorkerSchedulingOptions {
  public operation: number;
  public templates: DailyWorkerScheduleTemplate[] = [];

  static fromJson(oo: OperationDailyWorkerSchedulingOptions): OperationDailyWorkerSchedulingOptions {
    let t: OperationDailyWorkerSchedulingOptions = new OperationDailyWorkerSchedulingOptions();
    t.operation = oo.operation;
    t.templates = [];
    if (oo.templates != null)
      oo.templates.forEach(e => {
        t.templates.push(DailyWorkerScheduleTemplate.fromJson(e));
      });
    return t;
  }
}

/**
 * Reporting & Slot Planning Progress
 **/

export class SlotPoolAsssignmentReport {
  resourcePool: string;
  totalNumberOfSlots: number;
  numberOfPlannedSlots: number;
}

export class SlotAssignReportRange {
  rangeName: string;
  poolSlotReports: SlotPoolAsssignmentReport[] = [];

  uiIsVisible: boolean;
}

export class SlotAssignmentPerPoolReport {
  rangeReports: SlotAssignReportRange[] = [];

  static fromJson(e: SlotAssignmentPerPoolReport) {
    return e;
  }
}



// WEBPACK FOOTER //
// ./src/model/ReportingSlots.ts